module.exports = __webpack_public_path__ + "static/img/kycPassed.81741d53.svg";